module.exports = __webpack_public_path__ + "img/logo.d8130bc0.svg";